// Нижняя панель — целиком из config.navigation.tab_bar: состав, порядок, подписи, иконки. Своего списка нет.
// Прячется при прокрутке вниз и возвращается при прокрутке вверх (Figma, «Скролл вниз»).
import { useEffect, useState } from 'react';
import { useLocation } from 'react-router-dom';
import { haptic } from '../telegram/webapp';
import { TabIcon } from './Icon';
import styles from './TabBar.module.css';

const THRESHOLD = 8; // px за событие: дрожь пальца панель не дёргает
const TOP_ZONE = 80; // у верха страницы панель всегда видна
const INPUT_WINDOW = 700; // мс: прокрутка без жеста (автоякорь «Сегодня», scrollTo) панель не прячет

export function useHideOnScroll(): boolean {
  const [hidden, setHidden] = useState(false);
  const { pathname } = useLocation();
  useEffect(() => setHidden(false), [pathname]);
  useEffect(() => {
    let last = window.scrollY;
    let lastInput = 0;
    const onInput = () => { lastInput = performance.now(); };
    const onScroll = () => {
      const y = window.scrollY;
      const delta = y - last;
      const byUser = performance.now() - lastInput < INPUT_WINDOW;
      if (y < TOP_ZONE) setHidden(false);
      else if (byUser && delta > THRESHOLD) setHidden(true);
      else if (byUser && delta < -THRESHOLD) setHidden(false);
      if (!byUser || Math.abs(delta) > THRESHOLD || y < TOP_ZONE) last = y;
    };
    const inputs = ['touchmove', 'wheel', 'keydown'] as const;
    inputs.forEach((e) => window.addEventListener(e, onInput, { passive: true }));
    window.addEventListener('scroll', onScroll, { passive: true });
    return () => {
      inputs.forEach((e) => window.removeEventListener(e, onInput));
      window.removeEventListener('scroll', onScroll);
    };
  }, []);
  useEffect(() => {
    document.documentElement.toggleAttribute('data-tabbar-hidden', hidden);
  }, [hidden]);
  return hidden;
}

/** Вкладка панели (config.navigation.tab_bar.items[]): icon — имя из ресурсов приложения, не адрес. */
export interface TabBarItem { key: string; label: string; icon: string; url: string }

export function TabBar({ items, active, onSelect }: { items: TabBarItem[]; active: string; onSelect: (key: string) => void }) {
  const hidden = useHideOnScroll();
  return (
    <nav className={`${styles.bar} ${hidden ? styles.hidden : ''}`}>
      {items.map((item) => {
        const selected = item.key === active;
        return (
          <button key={item.key} className={`${styles.tab} ${selected ? styles.selected : ''}`}
            aria-current={selected ? 'page' : undefined}
            onClick={() => { if (!selected) haptic.selection(); onSelect(item.key); }}>
            <TabIcon name={item.icon} filled={selected} />
            <span className={styles.label}>{item.label}</span>
          </button>
        );
      })}
    </nav>
  );
}
